import { useGetLowStockQuery } from '@/features/slice/inventory';
import { useStockListApiQueryParams } from '@/modules/stocks/shared';

export const useLowStockList = () => {
    const queryParams = useStockListApiQueryParams();

    const { data, isFetching, isLoading, isError, error } =
        useGetLowStockQuery(queryParams);
    return {
        data,
        error,
        isFetching,
        isLoading,
        isError,
    };
};
